module.exports = __webpack_public_path__ + "assets/58f782b8e424dd4971708183c2e841a2.png";